// Helper functions for storing and retrieving Query Parameters from the URL

// add type for query_parameters to global window object
declare global {
  interface Window {
    queryParams: URLSearchParams
  }
}

export const storeQueryParameters = (params: string[]) => {
  const currentQueryParams = new URLSearchParams(window.location.search)
  window.queryParams = new URLSearchParams()

  params.forEach((param) => {
    const value = currentQueryParams.get(param)
    if (!value) return

    window.queryParams.append(param, value)
  })
}

export const clearQueryParameters = (params: string[]) => {
  const queryParams = new URLSearchParams(window.location.search)

  params.forEach((param) => {
    queryParams.delete(param)
  })

  history.replaceState(
    null,
    '',
    `${window.location.pathname}?${queryParams.toString()}`,
  )
}

export const getQueryParameter = (name: string) => {
  return window.queryParams?.get(name)
}

export const getQueryParametersString = () => {
  return window.queryParams?.toString() || ''
}

export const storeAndClearQueryParameters = (params: string[]) => {
  storeQueryParameters(params)
  clearQueryParameters(params)
}
